import { VerificationRequestType } from '../notification-configuration/VerificationRequest.model';

export const OpenVerificationSubmissionStatus = {
    ALREADY_SUBMITTED: 'ALREADY_SUBMITTED',
    AWAITING_SUBMISSION: 'AWAITING_SUBMISSION',
} as const;

export type OpenVerificationSubmissionStatus =
    (typeof OpenVerificationSubmissionStatus)[keyof typeof OpenVerificationSubmissionStatus];

// Not in VerificationRequestType, which lists the request types an RP configures notifications for.
export const ON_DEMAND_VERIFICATION_TYPE = 'ON_DEMAND';

export interface OpenVerificationRequirement {
    coverageType: string;
    instanceId: string | null;
    submissionStatus: OpenVerificationSubmissionStatus;
    // Why this requirement was requested. NON_COMPLIANT means it is already a follow-up request; ON_DEMAND is one a
    // client asked for directly, which forcing treats like NEW.
    verificationType: Extract<VerificationRequestType,
        VerificationRequestType.new | VerificationRequestType.nonCompliant | VerificationRequestType.expiring>
        | typeof ON_DEMAND_VERIFICATION_TYPE;
    // Set only once the entity has answered this requirement.
    receivedAt: string | null;
}

/** A verification the entity is still answering one requirement at a time. */
export interface OpenVerification {
    verificationId: string;
    requestedAt: string;
    requirements: OpenVerificationRequirement[];
    // Why forcing would be refused right now (the reason the force endpoint's 409 carries), or null if it can be.
    forceSubmissionRefusal: ForceSubmissionConflictReason | null;
}

export interface OpenVerificationResponse {
    openVerification: OpenVerification | null;
}

export const ForceSubmissionConflictReason = {
    NOT_PENDING: 'NOT_PENDING',
    NOTHING_RECEIVED: 'NOTHING_RECEIVED',
    NOTHING_MISSING: 'NOTHING_MISSING',
    // A missing requirement the entity can't answer itself, such as a Motor Vehicle Record check.
    UNSUPPORTED_MISSING_REQUIREMENT: 'UNSUPPORTED_MISSING_REQUIREMENT',
} as const;

export type ForceSubmissionConflictReason =
    (typeof ForceSubmissionConflictReason)[keyof typeof ForceSubmissionConflictReason];
